import axios from 'axios'
import { notificationDanger } from '../../../../../../utils/customToastify'
import {
  ACTIVITY_SUMMARY_CONTACTS,
  ACTIVITY_SUMMARY_LOADING,
  CLEAR_ACTIVITY_SUMMARY_CONTACTS,
  GET_PAS_DUE_TASKS_COUNT,
  GET_SUMMARY_ACCOUNTS,
  GET_SUMMARY_CALLS,
  GET_SUMMARY_CALL_TIME,
  GET_SUMMARY_DEMOS,
  GET_SUMMARY_EMAILS,
  GET_SUMMARY_GIVE_UPS,
  GET_SUMMARY_INCOMING_CALLS,
  GET_SUMMARY_INCOMING_CALL_TIME,
  GET_SUMMARY_LONG_CALLS,
  GET_SUMMARY_MEETINGS,
  GET_SUMMARY_PROSPECTS,
  GET_SUMMARY_REFERRALS,
} from './types'

import moment from 'moment'
import isEmpty from '../../../../../../utils/isEmpty'
import {
  ACCOUNTS_TYPE,
  activityTypes,
  CALLS_TYPE,
  CALL_TIME_TYPE,
  DEMOS_TYPE,
  EMAILS_TYPE,
  GIVE_UPS_TYPE,
  INCOMING_CALLS_TYPE,
  INCOMING_CALL_TIME_TYPE,
  LONG_CALLS_TYPE,
  mapActivityTypeToProps,
  MEETINGS_TYPE,
  PROSPECTS_TYPE,
  REFERRALS_TYPE,
} from './constants'

const validateDateRange = (dateRange) => {
  if (!dateRange) {
    return false
  }
  const { from, to } = dateRange

  if (!from || !to) {
    return false
  } else {
    return true
  }
}

const dispatchByType = (activityType, data, dispatch) => {
  switch (activityType) {
    case CALLS_TYPE:
      dispatch({ type: GET_SUMMARY_CALLS, payload: data.calls })
      return
    case CALL_TIME_TYPE:
      dispatch({ type: GET_SUMMARY_CALL_TIME, payload: data.callTime })
      return
    case INCOMING_CALLS_TYPE:
      dispatch({ type: GET_SUMMARY_INCOMING_CALLS, payload: data.incomingCalls })
      return
    case INCOMING_CALL_TIME_TYPE:
      dispatch({ type: GET_SUMMARY_INCOMING_CALL_TIME, payload: data.incomingCallTime })
      return
    case EMAILS_TYPE:
      dispatch({ type: GET_SUMMARY_EMAILS, payload: data.emails })
      return
    case DEMOS_TYPE:
      dispatch({ type: GET_SUMMARY_DEMOS, payload: data.demos })
      return
    case MEETINGS_TYPE:
      dispatch({ type: GET_SUMMARY_MEETINGS, payload: data.meetings })
      return
    case PROSPECTS_TYPE:
      dispatch({ type: GET_SUMMARY_PROSPECTS, payload: data.prospects })
      return
    case ACCOUNTS_TYPE:
      dispatch({ type: GET_SUMMARY_ACCOUNTS, payload: data.accounts })
      return
    case REFERRALS_TYPE:
      dispatch({ type: GET_SUMMARY_REFERRALS, payload: data.referrals })
      return
    case GIVE_UPS_TYPE:
      dispatch({ type: GET_SUMMARY_GIVE_UPS, payload: data.giveUps })
      return
    case LONG_CALLS_TYPE:
      dispatch({ type: GET_SUMMARY_LONG_CALLS, payload: data.longCalls })
      return

    default:
      return
  }
}

export const getPasDueTasksCount = () => async (dispatch) => {
  try {
    const response = await axios.get('/activity/summary/pas-due-tasks/count')
    dispatch({ type: GET_PAS_DUE_TASKS_COUNT, payload: +response.data?.count || 0 })
  } catch (e) {
    //
  }
}

export const getAllActivitiesSummary = (filters, isReset, cancelTokenSource) => async (dispatch) => {
  const isDateRangeValid = validateDateRange(filters?.dateRange)
  if (!isDateRangeValid) {
    notificationDanger('Please select date range!')
  } else {
    const baseDelay = 1000 // 1s
    dispatch({ type: ACTIVITY_SUMMARY_LOADING })
    activityTypes.forEach((activityType, index) => {
      setTimeout(() => {
        dispatch(getActivitySummary(filters, activityType, isReset, cancelTokenSource))
      }, baseDelay * index)
      if (index === activityTypes.length - 1) {
        setTimeout(() => {
          dispatch({ type: ACTIVITY_SUMMARY_LOADING })
        }, baseDelay * index + 1000)
      }
    })
  }
}

const getActivitySummary = (filters, activityType, isReset = false, cancelTokenSource) => async (
  dispatch,
  getState
) => {
  try {
    const offset = moment().utcOffset()
    const propName = mapActivityTypeToProps(activityType)
    const { dashboardActivitySummary: activitySummary } = getState()

    if (isEmpty(activitySummary[propName]) || isReset) {
      const response = await axios.get(`/activity/summary/${activityType}`, {
        params: { myFilters: { ...filters, utcOffset: offset } },
        cancelToken: cancelTokenSource?.token,
      })
      dispatchByType(activityType, response.data, dispatch)
    }
  } catch (e) {
    //
  }
}

export const getActivitySummaryContacts = (filters) => async (dispatch) => {
  try {
    const offset = moment().utcOffset()
    dispatch({ type: ACTIVITY_SUMMARY_LOADING })

    const response = await axios.get('/activity/summary/contacts', {
      params: { ...filters, filter: { ...filters.filter, utcOffset: offset } },
    })
    dispatch({ type: ACTIVITY_SUMMARY_CONTACTS, payload: response.data })
  } catch (error) {
    //
  } finally {
    dispatch({ type: ACTIVITY_SUMMARY_LOADING })
  }
}

export const clearActivitySummaryContacts = () => (dispatch) => {
  dispatch({ type: CLEAR_ACTIVITY_SUMMARY_CONTACTS })
}
